export default __webpack_public_path__ + "static/Refrigerator-Removal-b6a8a1274fb94e7c7656595eab88a324.jpg";